import React from 'react';
import { InboxIcon } from 'lucide-react';
export function EmptyState({
  message,
  detail
}: {
  message: string;
  detail?: string;
}) {
  return <div className="flex flex-col items-center justify-center px-6 py-20 text-center" data-id="element-316" data-mp="1jc2gsyc5fqo9">
      <span className="flex h-14 w-14 items-center justify-center rounded-full bg-ink-100 text-ink-400" data-id="element-317" data-mp="1odi28ri8nz76">
        <InboxIcon className="h-6 w-6" data-id="element-318" data-mp="1se20jyejt8uw" />
      </span>
      <p className="mt-4 text-[15px] font-bold text-ink-800" data-id="element-319" data-mp="voumtck6841j">{message}</p>
      {detail && <p className="mt-1 text-[13px] text-ink-500" data-id="element-320" data-mp="10nfeuop9rhew">{detail}</p>}
    </div>;
}